import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { of, Subject } from 'rxjs';
import { ProductData } from '../../../../../../core/model/Product.model';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { CheckoutService } from '../../utils/services/checkout.service';
import { LoginService } from '../../../../../../services/login/login.service';
import { HeightCartService } from '../../utils/services/height-cart.service';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tipo-compra',
  templateUrl: './tipo-compra.component.html',
  styleUrls: ['./tipo-compra.component.scss']
})
export class TipoCompraComponent implements OnInit {
  isMobile: boolean;
  public optionFormGroup: FormGroup;
  public messegeCredit: string;
  public creditStatus = false;
  public loading = false;
  public limiteCredito: number;
  public saldoActual: number;
  private unsubscribe$ = new Subject<void>();
  public totalPagar: number;
  public creditoDisponible: number = 0;
  public itemsCedis: ProductData[];
  public itemsSucursal: ProductData[];
  public OcultarBotonDeCredito: boolean;
  private validarLimiteDeCredito = 1;
  private validarCreditoDisponible = 1;
  private validarDocumentosVencidos = 1;
  private versionCreditoValidacion = 1.01;
  public continuarCart = new EventEmitter<boolean>(false);
  banderaObservables: boolean = false;
  banderaObservables2: boolean = false;
  selectedOption: string;
  contado: string;
  credito: string;
  permisoCredito: number;
  permisoCredito2: number;
  flagPermiso: boolean;
  creditoAuth: any;
  creditoSuspend: any;
  blockCredit: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private cartService: CartService,
    private service: CheckoutService,
    private login: LoginService,
    private sharedService: HeightCartService,
  ) {
    this.contado = 'contado';
    this.credito = 'credito'
  }

  ngOnInit(): void {
    console.log("tipo compra init")
    let pasarela: any = localStorage.getItem("pasarela-pago");
    if (!pasarela) {
      localStorage.setItem("pasarela-pago", "efectivo");
    }
    const screenWidth = window.innerWidth;
    this.isMobile = screenWidth < 770;
    this.resumenCompra(); // Optenemos el total de la compra.
    this.optionFormGroup = this.formBuilder.group({ // Inicializamos el formulario
      tipoCompra: [''],
    });
    this.updateForm(); // estado del formulario, desctivar cuando se  estegenerando el pedido y activar cuando se termine de activar.
    this.valueChangesForm();
    const tpPago = localStorage.getItem('tipo-pago'); // Credito o contado
    const PG = this.login.getDataClientePedido().es_publicogeneral === 'SI'; // valida si es cliente publico general.
    this.optionFormGroup.get('tipoCompra').setValue(tpPago === 'contado' ? 'contado' : (PG ? 'contado' : 'credito'));
    this.checkCredit(); // Revisamos el historial de  credito del cliente.

    this.sharedService.getDataCreditoAuth().subscribe((data) => {
      this.creditoAuth = data;
      this.banderaObservables = true;
      // console.log("NO ME LO VAS A CREER OoO",this.creditoAuth);
      if (this.creditoAuth == 1) {
        this.selectedOption = 'credito';
        this.sharedService.tipoDeCompra = false;
      }
      this.tablaDeCredito();

    });

    this.sharedService.getDataCreditoSuspend().subscribe((data) => {
      this.creditoSuspend = data;
      this.banderaObservables2 = true;
      // console.log("NO ME LO VAS A CREER 7w7",this.creditoSuspend);

      if (this.creditoSuspend == 1) {
        this.selectedOption = 'contado';
        this.sharedService.tipoDeCompra = false;
      }
      this.tablaDeCredito();

    });
  }

  tablaDeCredito() {
    if (this.banderaObservables === true && this.banderaObservables2 === true) {
      if (this.creditoAuth == 0 && this.creditoSuspend == 0) {
        this.blockCredit = false;
      }
      if (this.creditoAuth == 1 && this.creditoSuspend == 1) {
        this.blockCredit = false;
      }
      if (this.creditoAuth == 0 && this.creditoSuspend == 1) {
        this.blockCredit = false;
      }
      if (this.creditoAuth == 1 && this.creditoSuspend == 0) {
        this.blockCredit = true;
      }
    }
  }

  getTipoCompra() {
    this.sharedService.tipoDeCompra = true;
  }

  getTipoCompraDefault() {
    this.sharedService.tipoDeCompra = false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  private valueChangesForm(): void {

    this.optionFormGroup.get('tipoCompra').valueChanges.pipe(debounceTime(200),
      takeUntil(this.unsubscribe$)
    ).subscribe(value => {
      this.service.addTipoDeCompra$(value);
    });
  }

  public resumenCompra = () => {
    this.cartService.resumen$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      // console.log('is data', data.total);
      this.totalPagar = data.total;
    });
  }
  public validPrecioCredit = () => {
    if (this.totalPagar > this.creditoDisponible) {
      return true;
    }
    return false;
  }
  private checkCredit = () => {
    this.loading = true;
    /**
     *   opcionDefaultZafiroContadoCredito es la opcion de como esta catalogado el cliente en zafiro.
     *   si cuenta con credito disponible o si es cliente de contado.
    */
    let opcionDefaultZafiroContadoCredito = '';
    let banderaOpcionDefaultZafiroContadoCredito: boolean;

    this.cartService.checkCredit().pipe(takeUntil(this.unsubscribe$), switchMap(responseData => {
      opcionDefaultZafiroContadoCredito = '';
      // console.log("I'm here", responseData.resultados.SaldoVencido);
      this.sharedService.setData(responseData.resultados.SaldoVencido);
      this.sharedService.setDataCreditoAuth(responseData.resultados.CreditoAutorizado);
      this.sharedService.setDataCreditoSuspend(responseData.resultados.CreditoSuspendido);
      this.sharedService.setClienteSuspendo(responseData.resultados.Baja);
      // console.log("I'M RIGHT HEREEEEEEEE",responseData)
      // console.log('checkCredit()');
      /**
       * Actualizamos el precio de la paqueteria a como esta en el catalogo de articulos.
       *
       */
      this.cartService.setPrecioPaqueteria(responseData?.resultados?.PrecioPaqueteria);

      this.getItemsCart();
      if (responseData.resultados !== undefined && responseData.resultados !== null) {
        if (responseData?.resultados?.VLimiteDeCredito !== undefined && responseData?.resultados?.VLimiteDeCredito !== null) {
          this.validarLimiteDeCredito = responseData?.resultados?.VLimiteDeCredito;
        }
        if (responseData?.resultados?.VCreditoDisponible !== undefined && responseData?.resultados?.VCreditoDisponible !== null) {
          this.validarCreditoDisponible = responseData?.resultados?.VCreditoDisponible;
        }
        if (responseData?.resultados?.VDocumentosVencidos !== undefined && responseData?.resultados?.VDocumentosVencidos !== null) {
          this.validarDocumentosVencidos = responseData?.resultados?.VDocumentosVencidos;
        }
        if (responseData?.resultados?.VCValidacion !== undefined && responseData?.resultados?.VCValidacion !== null) {
          this.versionCreditoValidacion = responseData?.resultados?.VCValidacion;
        }
      }
      if (responseData.resultados) {
        this.saldoActual = Number(responseData.resultados.Saldo);
        this.limiteCredito = Number(responseData.resultados.LimiteCreditoP);
        //Se toma el valor del limite de credito desde el servidor.
        console.log('CRD= > {}', responseData.resultados.LimiteCredito)
        this.creditoDisponible = responseData.resultados.LimiteCredito; //this.limiteCredito - this.saldoActual;
      }
      switch (responseData.opcion) {
        case 'Limite_excedido ':
          if (this.versionCreditoValidacion > 1.01) {
            if (this.validarLimiteDeCredito == 1) {
              this.messegeCredit = 'Crédito excedido. ha execido su limite de crédito';
              this.creditStatus = false;
              this.OcultarBotonDeCredito = responseData.resultados.OcultarBotonDeCredito;
            } else if (this.validarLimiteDeCredito == 0) {
              this.messegeCredit = 'Crédito excedido. Genera tu pedido y comunicate con el area de CXC para revisar tu linea de crédito.';
              this.creditStatus = true;
            }
          } else if (this.versionCreditoValidacion <= 1.01) {
            if (this.itemsSucursal?.length > 0) {
              this.messegeCredit = 'Crédito excedido. ha execido su limite de crédito';
              this.creditStatus = false;
              this.OcultarBotonDeCredito = responseData.resultados.OcultarBotonDeCredito;
            } else if (this.itemsCedis?.length > 0 && this.itemsSucursal?.length <= 0) {
              this.messegeCredit = 'Crédito excedido. Genera tu pedido y comunicate con el area de CXC para revisar tu linea de crédito.';
              this.creditStatus = true;
            }
          }
          return of('contado');
          break;
        case 'Cuenta_sin_credito':
          this.messegeCredit = 'Sin crédito disponible, No cuenta con el crédito suficiente para esta compra.';
          if (this.versionCreditoValidacion > 1.01) { // Nueva validacion.
            if (this.validarCreditoDisponible == 1) {
              this.messegeCredit = 'Sin crédito disponible, No cuenta con el crédito suficiente para esta compra.' + responseData.status;
              this.creditStatus = false;
              this.OcultarBotonDeCredito = responseData.resultados.OcultarBotonDeCredito;
            } else if (this.validarCreditoDisponible == 0) { // PedidoCondicionado
              this.messegeCredit = 'Sin crédito disponible. Genera tu pedido y comunicate con el area de CXC para revisar tu linea de crédito.' + responseData.status;
              this.creditStatus = true;
            }
          } else if (this.versionCreditoValidacion <= 1.01) { // Validaciones como estan actualmente 23/01/2023
            if (this.itemsSucursal?.length > 0) {
              this.messegeCredit = 'Sin crédito disponible, No cuenta con el crédito suficiente para esta compra.';
              this.creditStatus = false;
              this.OcultarBotonDeCredito = responseData.resultados.OcultarBotonDeCredito;
            } else if (this.itemsCedis?.length > 0) { // aquí no se
              this.messegeCredit = 'Sin crédito disponible. Genera tu pedido y comunicate con el area de CXC para revisar tu linea de crédito.';
              this.creditStatus = true;
            }
          }

          return of('contado');
          break;
        case 'Cuenta_inactiva':
          this.messegeCredit = 'La cuenta del cliente se encuentra inactiva. Comunicarse con el area de CXC para revisar el estado de cuenta.';
          this.creditStatus = false;
          this.OcultarBotonDeCredito = responseData.resultados.OcultarBotonDeCredito;
          return of('contado');
          break;
        case 'Documentos_vencidos':

          this.messegeCredit = 'Saldo vencido. Su cuenta presenta saldo vencido.';
          if (this.versionCreditoValidacion > 1.01) { // Nueva validacion.
            if (this.validarDocumentosVencidos == 1) {
              this.messegeCredit = 'Saldo vencido. ' + responseData.status;
              this.creditStatus = false;
              this.OcultarBotonDeCredito = responseData.resultados.OcultarBotonDeCredito;
            } else if (this.validarDocumentosVencidos == 0) { // PedidoCondicionado
              this.messegeCredit = 'Saldo vencido. Genera tu pedido y comunicate con el area de CXC para revisar el saldo vencido de tu cuenta. ' + responseData.status;
              this.creditStatus = true;
            }
          }
          return of('contado');
          break;
        default:
          this.messegeCredit = 'Crédito disponible.';
          this.creditStatus = true;
          return of('credito');
          break;
      }
    }), switchMap((CreditoContado: string) => {
      opcionDefaultZafiroContadoCredito = CreditoContado;
      /**
       * Recalcular Resumen es una bandera que indica cuando el resumen de compra a sido modificando.
       * Cuando seleccionas envio por paqueteria se actualiza el resumen de compra y se debe de recalcular el credito disponible.
       */
      return this.service.getRecalculaResumen$().pipe(takeUntil(this.unsubscribe$));
    }), switchMap((recalcular: boolean) => {
      // console.log('Recalcula el credito:: ', recalcular);
      return this.service.getTipoDeCompra$().pipe(takeUntil(this.unsubscribe$));
    })).subscribe((tipoDeCompra: string) => {
      //  console.group('Star subscribe');
      const items = this.getItemsCart();
      const validPrecioCredit = this.validPrecioCredit();
      let error: boolean = false;
      let tipoCompraTemp = tipoDeCompra;
      //  console.log('error=>{} => start :',error);
      //  console.log('mensaje credit=>{} => start :',this.messegeCredit);
      //  console.log('is valid Credit', validPrecioCredit);
      if (tipoDeCompra === 'credito' && this.creditStatus) {

        if (this.versionCreditoValidacion > 1.01) {

          if (validPrecioCredit && this.validarLimiteDeCredito == 1) {
            this.messegeCredit = 'Crédito excedido. ha execido su limite de crédito';
            error = true;
          } else if (this.validarLimiteDeCredito == 0) {
            this.messegeCredit = 'Crédito excedido. Genera tu pedido y comunicate con el area de CXC para revisar tu linea de crédito.';
            error = false;
          } else {
            this.messegeCredit = 'Crédito disponible.';
            error = false;
          }
        } else if (this.versionCreditoValidacion <= 1.01) {

          if (validPrecioCredit && this.itemsSucursal?.length > 0) {
            this.messegeCredit = 'Crédito excedido. ha execido su limite de crédito';
            error = true;
          } else if (this.itemsCedis?.length > 0 && this.itemsSucursal?.length <= 0 && validPrecioCredit) {
            this.messegeCredit = 'Crédito excedido. Genera tu pedido y comunicate con el area de CXC para revisar tu linea de crédito.';
            error = false;
          } else {
            this.messegeCredit = 'Crédito disponible.';
            error = false;
          }
          // console.log('error=>{} => :',error);
          // console.log('mensaje credit=>{} => :',this.messegeCredit);
          // console.log('******Tipo de compra credito');
        }
      } else if (tipoDeCompra === 'contado') {
        error = false;
      } else {
        this.setValue('contado');
        error = false;
      }
      // console.log('error=>{} end :',error);
      // Si tenemos credito y en zafiro por dafult tenemos creito
      // Solo debe de entrar una vez /
      if (!error && !banderaOpcionDefaultZafiroContadoCredito && opcionDefaultZafiroContadoCredito == 'credito' && tipoDeCompra == 'contado') {
        // console.log('*Si Credito*');
        localStorage.setItem('tipo-pago', opcionDefaultZafiroContadoCredito);
        this.setValue(opcionDefaultZafiroContadoCredito);
        tipoCompraTemp = opcionDefaultZafiroContadoCredito;
      }
      //Si no tenemos credito en zafiro, pero tenemos seleccionado la opcion de credito, debemos de seleccionar en automatico la opcion de contado.
      if (!error && !banderaOpcionDefaultZafiroContadoCredito && opcionDefaultZafiroContadoCredito == 'contado' && tipoDeCompra == 'credito') {
        // console.log('*No Credito*');
        localStorage.setItem('tipo-pago', opcionDefaultZafiroContadoCredito);
        this.setValue(opcionDefaultZafiroContadoCredito);
        tipoCompraTemp = opcionDefaultZafiroContadoCredito;
      }
      localStorage.setItem('tipo-pago', tipoCompraTemp);
      // console.log('en ERP',opcionDefaultZachfiroContadoCredito);
      // console.log('en WEB',tipoDeCompra);
      // console.log('end emit*****')
      // console.groupEnd();
      this.cartService.calcularResumen(items);
      this.service.addLimiteDeCredito$(error, this.messegeCredit, tipoCompraTemp);
      this.loading = false;
      banderaOpcionDefaultZafiroContadoCredito = true;
    },
      error => {
        console.error(error)
      }, () => {
        console.log('Complete..')
      });
  }
  private updateForm() {
    this.service.getformularioCheckout$().pipe(takeUntil(this.unsubscribe$)).subscribe((activo: Boolean) => {
      console.log('formulario', activo);
      if (activo) {
        this.optionFormGroup.disable();
      } else {
        this.optionFormGroup.enable();
      }
    });
    // this.optionFormGroup.enabled;
  }
  private getItemsCart(): ProductData[] {
    const items: ProductData[] = JSON.parse(localStorage.getItem('items-cart-login'));
    this.itemsCedis = items.filter((item) => item.isCedis === true);
    this.itemsSucursal = items.filter((item) => item.isCedis === false);
    return items;
  }

  public getValue = () => {
    return this.optionFormGroup.get('tipoCompra').value;
  }
  private setValue = (newValue: string) => {
    this.optionFormGroup.get('tipoCompra').setValue(newValue);
  }

}
